export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../../views/Auth/LogIn'),
        meta: {
            layout: 'none',
            action: 'read',
        },
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('../../views/Auth/Signup/Index'),
        meta: {
            layout: 'none',
            action: 'read',
        },
    },
    {
        path: '/reset',
        name: 'reset',
        component: () => import('../../views/Auth/Reset/index'),
        meta: {
            layout: 'none',
            action: 'read',
        },
    },

]
